export const FORGOT_PASSWORD_EMAIL_STATUSES = {
    ongoing: 'FORGOT_PASSWORD_EMAIL_ONGOING',
    delivered: 'FORGOT_PASSWORD_EMAIL_DELIVERED',
    failed: 'FORGOT_PASSWORD_EMAIL_FAILED',
};

export const SOFT_ACCOUNT_EMAIL_STATUSES = {
    ongoing: 'SOFT_ACCOUNT_EMAIL_ONGOING',
    delivered: 'SOFT_ACCOUNT_EMAIL_DELIVERED',
    failed: 'SOFT_ACCOUNT_EMAIL_FAILED',
};

export const PASSWORDLESS_EMAIL_STATUSES = {
    ongoing: 'PASSWORDLESS_EMAIL_ONGOING',
    delivered: 'PASSWORDLESS_EMAIL_DELIVERED',
    failed: 'PASSWORDLESS_EMAIL_FAILED',
};

export const VERIFICATION_EMAIL_STATUSES = {
    ongoing: 'VERIFICATION_EMAIL_ONGOING',
    delivered: 'VERIFICATION_EMAIL_DELIVERED',
    failed: 'VERIFICATION_EMAIL_FAILED',
    limitReached: 'VERIFICATION_MAX_EMAILS_SENT',
};

export const VERIFICATION_STATUSES = {
    empty: 'VERIFICATION_EMPTY',
    success: 'VERIFICATION_SUCCESS',
    failed: 'VERIFICATION_FAILED',
    maxTries: 'VERIFICATION_TRIES_MAXED',
};
